<template>
  <nav v-if="breadcrumbs && breadcrumbs.length" aria-label="パンくずリスト">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" v-for="(crumb, key) in breadcrumbs">
        <span v-if="crumb.path"><router-link :to="crumb.path">{{ crumb.name }}</router-link></span>
        <span v-else>{{ crumb.name }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  props: {
    breadcrumbs: {
      type: Array
    }
  }
}
</script>
